import { PessoaLookupCombobox, type PessoaLookupComboboxProps } from "@/components/PessoaLookupCombobox";

/** Vendedor (pessoa marcada como Vendedor) por código, nome ou CPF — busca no servidor. */
export function VendedorSearchCombobox({ placeholder = "Selecione o vendedor...", ...props }: Omit<PessoaLookupComboboxProps, "papel">) {
  return <PessoaLookupCombobox {...props} papel="vendedor" placeholder={placeholder} />;
}
